import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { getCountryCode } from "../../../../helpers/utils";
import TabsRoot from "../../../molecules/tabs/TabsRoot";
import Text from "../../../molecules/content/Text";
import PhoneInputField from "../../../molecules/formControls/inputField/PhoneInputField";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import { RequestCodeValidation } from "./validations";

const RequestCodeForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const countryCode = getCountryCode();

  const initialValues = {
    loginMethod: "email",
    email: "",
    phone_number: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: RequestCodeValidation(t, countryCode),
    onSubmit,
  });

  const handleChangeTab = (value) => {
    formik.setFieldValue("loginMethod", value);
    if (value === "email") {
      formik.setFieldValue("phone_number", "");
      formik.setTouched({ ...formik.touched, phone_number: false });
    } else {
      formik.setFieldValue("email", "");
      formik.setTouched({ ...formik.touched, email: false });
    }
  };

  const tabsData = [
    {
      value: "email",
      label: t("signIn.email"),
      content: (
        <FloatingInputField
          id="email"
          name="email"
          label={t("signIn.email")}
          required={true}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          formikTouched={formik.touched.email}
          error={formik.errors.email}
        />
      ),
    },
    {
      value: "phone_number",
      label: t("signIn.phone"),
      content: (
        <PhoneInputField
          id="phone_number"
          name="phone_number"
          required={true}
          onChange={formik.handleChange}
          countryCode={countryCode}
          onBlur={formik.handleBlur}
          value={formik.values.phone_number}
          formikTouched={formik.touched.phone_number}
          error={formik.errors.phone_number}
        />
      ),
    },
  ];

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-8"
    >
      <div className="flex flex-col gap-4">
        <Text variant="h2" className="flex justify-center text-vestelColor">
          {t("requestCode.title")}
        </Text>
        <TabsRoot
          tabs={tabsData}
          defaultValue="email"
          isSub
          onValueChange={handleChangeTab}
        />
      </div>
      <Text variant="small" className="text-center">
        {t("requestCode.description")}
      </Text>
      <DefaultButton
        type="submit"
        label={t("requestCode.submit")}
        disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default RequestCodeForm;
